/** True when the app is served from the platform admin subdomain (e.g. admin.wildnetwork.app). */
export function isAdminSubdomain(host?: string): boolean {
  const value =
    host ??
    (typeof window !== "undefined" ? window.location.hostname : "");
  return value.startsWith("admin.");
}

export const ADMIN_PORTAL_LOGIN_PATH = "/login";
export const ADMIN_PORTAL_HOME_PATH = "/admin/overview";

/** Field-guide and other public pages are not routed on admin.*. */
export function publicSiteUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (typeof window === "undefined") return normalized;
  const host = window.location.hostname;
  if (!host.startsWith("admin.")) return normalized;
  const publicHost = host.replace(/^admin\./, "");
  return `${window.location.protocol}//${publicHost}${normalized}`;
}
